<!-- Bank Account Selection Button -->
<button
  id="account-selector-btn"
  matRipple
  (click)="openBankAccountDialog()"
  class="relative !ring-0 sm:!ring-1 !p-0 flex min-h-11 outline-none sm:!pr-3 sm:!p-0.5 sm:!mr-3 transition-all !rounded-full cursor-pointer max-w-60 truncate"
  [ngClass]="{
    'hoverable-card': siteStore.$bp().gtmd,
    'bg-white/10 backdrop-blur-sm !pl-1 !py-1': siteStore.$bp().sm
  }"
>
  <div class="flex items-center sm:gap-3 gap-1 pr-3 sm:px-0">
    <div
      class="w-10 h-10 sm:bg-primary-100 bg-transparent rounded-full flex items-center justify-center"
    >
      <app-wallet-icon
        class="sm:text-primary-500 text-primary-200"
        [width]="'30'"
        [height]="'30'"
      ></app-wallet-icon>
    </div>

    <div class="flex-col justify-start items-start flex">
      @if (bankAccountsStore.selectedBankAccount()) {
        <span class="truncate text-white sm:text-black">
          {{ formatedAccountNumber() }}
        </span>

        <!-- <span *ngIf="showBalance()" class="truncate font-light text-xs text-white sm:text-gray-500">
          {{ bankAccountsStore.selectedBankAccount()?.currency.symbol }}

          <span>
            {{ bankAccountsStore.selectedBankAccountBalance() | decimals }}
          </span>
        </span> -->

        <span class="truncate font-light text-xs text-white sm:text-gray-500 max-w-36">
          {{ bankAccountsStore.selectedBankAccount()?.currency.code }} -
          {{
            bankAccountsStore.selectedBankAccount()?.description ??
              bankAccountsStore.selectedBankAccount()?.accountType.name
          }}
        </span>
      } @else {
        <span class="truncate -mb-1 mt-0.5">Seleccionar Cuenta</span>
        <span class="truncate font-light text-xs">Ninguna cuenta seleccionada</span>
      }
    </div>

    <app-caret-down-icon
      *ngIf="siteStore.$bp().gtmd"
      class="hidden sm:inline ml-auto text-gray-500"
    ></app-caret-down-icon>
  </div>
</button>
